import React from "react";

const Footer = () => {
    return (
        <div style={{ height:60 }} />
    )
}

export default Footer;
